import React from "react";
import Login from "./screens/Login";
import Dashboard from "./screens/Dashboard";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useAuth } from "./providers/auth";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import Venues from "./screens/dashboard/Venues";
import Valets from "./screens/dashboard/Valets";
import Home from "./screens/dashboard/Home";
import Settings from "./screens/dashboard/Settings";
import Profile from "./screens/dashboard/Profile";
import NoMatch from "./screens/NoMatch";
import NotImplemented from "./screens/dashboard/NotImplemented";
import EditVenuePage from "./screens/dashboard/EditVenuePage";
import EditValetPage from "./screens/dashboard/EditValetPage";
import AddVenuePage from "./screens/dashboard/AddVenuePage";
import Realtime from "./screens/dashboard/Realtime";

export default () => {
  const queryClient = new QueryClient();
  const { loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen">
        <div className="m-auto">
          <span className="loading loading-dots loading-lg"></span>
        </div>
      </div>
    );
  }
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/sign-in" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          >
            <Route index element={<Home />} />
            <Route path="/realtime" element={<Realtime />} />
            <Route path="/valets" element={<Valets />} />
            <Route path="/valets/:valetId/edit" element={<EditValetPage />} />
            <Route path="/venues" element={<Venues />} />
            <Route path="/venues/add" element={<AddVenuePage />} />
            <Route path="/venues/:venueId/edit" element={<EditVenuePage />} />
            <Route path="profile" element={<Profile />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<NoMatch />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
};
